import React, { useState, useEffect, useContext } from "react";
import { viewportContext } from "../../../context/ViewportContext";

import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { IconButton, MenuItem } from "@material-ui/core";

import { getInitialRenderDate } from "../../../utils/dateHelpers";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  getUserById,
  getUserGroupById,
  getUserGroups,
  bulkUpdateUserGroup,
} from "../../../service/endpoint-manager";

import { useParams } from "react-router-dom";
import ShieldIcon from "@mui/icons-material/Shield";
import Tooltip from "@material-ui/core/Tooltip";
import { useSnackbar } from "notistack";
import Loading from "../Shared/Loading";
import clsx from "clsx";

import styles from "../../../styles.module.css"; // Importing CSS module for styles.
import ResetPasswordAdmin from "../Register/ResetPasswordAdmin";

const useStyles = makeStyles((theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#3f51b5",
    "&:hover": {
      cursor: "pointer",
    },
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },

  dateContainer: {
    display: "flex",
    "&>*": {
      flexBasis: "20%",
      flex: "1",
    },
  },

  yearContainer: {
    margin: "0 0 0 0.5rem",
    // margin: '0.5rem',
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    display: "flex",

    justifyContent: "center",

    [theme.breakpoints.down("md")]: {
      margin: "0",
      padding: "0.5rem",
    },
  },
  monthContainer: {
    margin: "0 5px 0 0",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "0",
      padding: "0.5rem",
    },
  },
  dayContainer: {
    margin: "0 5px",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "0",
      padding: "0.5rem",
    },
  },

  year: {
    width: "100%",
    outline: "none",
    borderRadius: "8%",
    padding: "0.7rem",
    paddingRight: "0",

    [theme.breakpoints.down("md")]: {
      maxHeight: "70vh",
      overflow: "scroll",
    },
  },

  month: {
    width: "100%",
    outline: "none",
    // border: '2px solid #F0B032',
    borderRadius: "8%",
    padding: " 0.7rem",
    paddingRight: "0",
    [theme.breakpoints.down("md")]: {
      maxHeight: "70vh",
      overflow: "scroll",
    },
  },

  day: {
    width: "100%",
    outline: "none",
    borderRadius: "8%",
    padding: "0.7rem",
    paddingRight: "0",
    [theme.breakpoints.down("md")]: {
      maxHeight: "70vh",
      overflow: "hidden",
    },
  },

  locationSelectStyles: {
    width: "100%",
  },

  input: {
    display: "none",
  },
  profileAvatar: {
    width: "50%",
    height: "50%",
  },

  btnStyles: {
    background: "#1B2132",
    color: "#fff",
    fontSize: "1rem",
    width: "100%",
    margin: "0.5rem 0",
    padding: "0.5rem",
  },

  dialogCancelBtn: {
    background: "#8a8a8a",
  },

  dialogStyles: {
    "& .MuiPaper-root": {
      width: "100%",
      maxWidth: "400px",
      borderRadius: "20px",
      paddingBottom: "1.25rem",
    },
  },

  dialogActionStyles: {
    display: "flex",
    justifyContent: "space-around",
    margin: "auto 1rem",
  },

  SaveButtonSection: {
    width: "40%",
    margin: "1rem 0",
  },
  menuItems: {
    display: "block",
    paddingRight: "15px",
    paddingLeft: "15px",
    marginTop: "5px",
    marginBottom: "5px",
  },
  dropdown: {
    borderTopRightRadius: "0",
    borderBottomRightRadius: "0",
    backgroundColor: "#f7f7f7",
  },
}));

const UserProfile = ({ openSidebar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { screenType } = useContext(viewportContext);
  const classes = useStyles();

  const [user, setUser] = useState(false);
  const [userGroup, setUserGroup] = useState(""); // the current user group
  const [userGroupList, setUserGroupList] = useState(null); // list of names of all user groups

  const [OpenUserGroupUpdateDialog, setOpenUserGroupUpdateDialog] =
    useState(false);

  const { id } = useParams();

  const { enqueueSnackbar } = useSnackbar();

  const [openResetPasswordDialog, setOpenResetPasswordDialog] =
    React.useState(false);

  // method to handle opening ResetPassword dialog
  const handleOpenResetPasswordDialog = () => {
    setOpenResetPasswordDialog(true);
  };

  // method to handle closing ResetPassword dialog
  const handleCloseResetPasswordDialog = () => {
    setOpenResetPasswordDialog(false);
  };

  const handleUpdateUserGroupDialog = async (userGroupId, selectedUser) => {
    setIsSubmitting(true);
    const result = await bulkUpdateUserGroup(userGroupId, selectedUser);
    if (result?.status === 200) {
      enqueueSnackbar(`${result?.data?.message}`, { variant: "success" });
    } else {
      enqueueSnackbar(`${result?.response?.data?.message}`, {
        variant: "error",
      });
    }
    setIsSubmitting(false);
    setOpenUserGroupUpdateDialog(false);
  };

  const handleCloseUserGroupUpdateDialog = () => {
    setOpenUserGroupUpdateDialog(false);
  };

  useEffect(() => {
    setIsLoading(true);
    const getUser = async () => {
      const result = await getUserById(id);
      if (result?.status === 200) {
        setUser(result.data?.body?.userData);
      }
    };
    getUser();

    setIsLoading(false);
  }, []);

  // fetch a list of names of all user groups
  useEffect(() => {
    const getUserGroupList = async () => {
      setIsLoading(true);
      const result = await getUserGroups();

      if (result?.status === 200) {
        setUserGroupList([...result?.data?.body?.Items]);
      }
      setIsLoading(false);
    };

    getUserGroupList();
  }, []);

  useEffect(() => {
    if (user) {
      setIsLoading(true);
      const getUserGroup = async () => {
        const result = await getUserGroupById(user.userGroup);
        if (result?.status === 200) {
          setUserGroup(result.data?.body);
        }
      };
      getUserGroup();

      setIsLoading(false);
    }
  }, [user]);

  const handleChangeUserGroup = (e) => {
    setUserGroup(
      userGroupList?.find((userGroup) => userGroup?.name === e.target.value)
    );
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      gender: "female",
      dob: "",
      dp: "",
      fullName: user?.fullName,
      username: user?.userName,
      email: user?.email,
    },
    onSubmit: function (values) {
      // console.log("values");
    },

    // validation schema for formik using yup
    validationSchema: Yup.object({
      // name must be text only and is required
    }),
  });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginLeft: openSidebar ? "250px" : "0", // Adjust the left margin based on sidebar state
        transition: "margin-left 0.3s ease", // Add a transition for smooth animation
        minWidth: screenType.isMobile ? "400px" : "480px",
      }}
    >
      <CssBaseline />
      <div className={styles.flexColumnCenter}>
        <Typography
          classes={styles.userProfileTitle}
          component="h1"
          variant="h5"
        >
          {user?.fullName}'s Profile
        </Typography>
        <form
          onSubmit={formik.handleSubmit}
          className={styles.userProfileMargin10}
          noValidate
        >
          <Grid container spacing={2}>
            {/* profile picture */}

            <Grid
              item
              xs={12}
              className={
                screenType?.isMobile
                  ? styles.flexColumnCenter
                  : styles.flexCenter
              }
            >
              <span style={{ justifyContent: "flex-start" }}>
                <label htmlFor="icon-button-file">
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    disabled={true}
                  >
                    <Avatar
                      src="https://www.w3schools.com/howto/img_avatar.png"
                      className={styles.profileAvatar}
                    />
                  </IconButton>
                </label>
              </span>
              <span
                className={
                  screenType.isMobile ? { display: "flex" } : styles.floatLeft
                }
              >
                {user?.fullName || "No name available"}
              </span>
            </Grid>
            {/* fullName */}
            <Grid item xs={12}>
              <TextField
                error={formik.touched.fullName && formik.errors.fullName}
                required
                fullWidth
                id="fullName"
                name="fullName"
                autoComplete="fullName"
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.fullName}
                disabled={true}
                className={screenType.isMobile ? "" : styles.floatRight70}
              />
              {
                <div
                  style={{
                    color: "red",
                    fontSize: "0.6rem",
                    visibility:
                      formik.touched.fullName && formik.errors.fullName
                        ? "visible"
                        : "hidden",
                  }}
                >
                  {formik.errors.fullName || "Full Name is required"}
                </div>
              }
            </Grid>
            {/* username */}
            <Grid item xs={12}>
              <TextField
                error={formik.touched.username && formik.errors.username}
                required
                fullWidth
                id="username"
                name="username"
                autoComplete="username"
                variant="outlined"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.username}
                disabled={true}
                className={screenType.isMobile ? "" : styles.floatRight70}
              />
              {
                <div
                  style={{
                    color: "red",
                    fontSize: "0.6rem",
                    visibility:
                      formik.touched.username && formik.errors.username
                        ? "visible"
                        : "hidden",
                  }}
                >
                  {formik.errors.username || "Username required"}
                </div>
              }
            </Grid>

            <Grid item xs={12}>
              <FormControl
                variant="outlined"
                className={screenType.isMobile ? "" : styles.floatRight70}
                style={{ width: "100%", marginBottom: "1rem" }}
              >
                {userGroupList && userGroup && (
                  <>
                    <label>User Group</label>
                    <Select
                      option={userGroupList}
                      defaultValue={userGroup?.ID}
                      value={userGroup?.name}
                      className={clsx(styles.dropdown)}
                      onChange={(e) => {
                        handleChangeUserGroup(e);
                      }}
                    >
                      {userGroupList?.map((ug) => {
                        return (
                          ug?.template !== true && (
                            <MenuItem
                              key={ug?.ID}
                              value={ug?.name}
                              selected={ug?.name}
                              className={classes.menuItems}
                            >
                              {ug?.name}
                              {ug?.isAdmin && (
                                <Tooltip
                                  arrow
                                  title="Admin Access"
                                  placement="top-start"
                                >
                                  <ShieldIcon style={{ width: "1rem" }} />
                                </Tooltip>
                              )}
                            </MenuItem>
                          )
                        );
                      })}
                    </Select>
                  </>
                )}
              </FormControl>

              <span className={classes.SaveButtonSection}></span>
            </Grid>
          </Grid>
          <div className={styles.buttonDiv}>
            {/* Reset Password button */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={`${styles.secondaryButton} ${styles.resetButton}`}
              onClick={(e) => {
                e.preventDefault();
                handleOpenResetPasswordDialog();
              }}
            >
              Reset Password
            </Button>

            <Button
              variant="contained"
              className={`${styles.saveButton} ${styles.primaryButton}`}
              onClick={() => {
                // open userGroup update confirmation dialog
                setOpenUserGroupUpdateDialog(true);
              }}
            >
              Save
            </Button>
          </div>
        </form>
      </div>
      <Dialog
        scroll="paper"
        open={openResetPasswordDialog}
        onClose={handleCloseResetPasswordDialog}
        maxWidth="lg"
        className={styles.dialogStyles}
      >
        <DialogContent className={styles.flexCenter}>
          <ResetPasswordAdmin
            handleCloseResetPasswordDialog={handleCloseResetPasswordDialog}
            userName={user?.userName}
          />
        </DialogContent>
      </Dialog>
      <Dialog
        open={OpenUserGroupUpdateDialog}
        onClose={handleCloseUserGroupUpdateDialog}
        maxWidth="lg"
        className={classes.dialogStyles}
      >
        <DialogTitle id="update-userGroup-dialog">Update UserGroup</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The user will be associated with the selected userGroup. Do you want
            to proceed?
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActionStyles}>
          <Button
            onClick={handleCloseUserGroupUpdateDialog}
            className={clsx(styles.redButton)}
          >
            Cancel
          </Button>
          <Button
            onClick={() =>
              handleUpdateUserGroupDialog(userGroup?.ID, [user?.user_id])
            }
            className={clsx(styles.primaryButton)}
            disabled={isSubmitting}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default UserProfile;
